var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionModal',{attrs:{"title":"Message envoyé avec succès !","subtitle":"Sociis diam et aliqua? Nonummy sint consequat sunt, elit pretium libero vestibulum! Do nesciunt nisi.","button":"Terminé"}})}
var staticRenderFns = []

export { render, staticRenderFns }